var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.state = !_vm.state}}},[_vm._v("Toggle")])],1),_vm._v(" "),_c('v-alert',{attrs:{"color":"success","value":_vm.state,"transition":"scale-transition"}},[_vm._v("\n      Whoops! An error occured!\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9fb5104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleBtn.vue
// module id = null
// module chunks = 